import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import classNames from 'classnames';
import BackgroundImage from 'gatsby-background-image';

import { Title } from 'components/typography';
import HighlightedText from 'components/highlightedText';

import {
  landingSectionContainer,
  landingSectionRow,
  leftCol,
  rightCol,
  sectionTitle,
  highlightedText,
  mainImageSection,
  marginBottomXs,
} from './scss/AboutPageIntro.module.scss';

const AboutPageIntro = () => {
  const bgImageData = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "about/about-page-landing.jpg" }) {
        childImageSharp {
          fluid(quality: 90, maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  return (
    <section className={landingSectionContainer}>
      <section className={landingSectionRow}>
        <div className={leftCol} />
        <div className={rightCol}>
          <Title
            value={
              <>
                <q>
                  Always
                  <HighlightedText
                    value="listening"
                    className={highlightedText}
                  />
                </q>
                <span>,</span>
              </>
            }
            fontStyle="regular"
            size="lg"
            className={classNames(sectionTitle, marginBottomXs)}
          />
          <Title
            value={
              <q>
                Always
                <HighlightedText
                  value="improving"
                  className={highlightedText}
                />
              </q>
            }
            fontStyle="regular"
            size="lg"
            className={sectionTitle}
          />
        </div>
      </section>
      <BackgroundImage
        Tag="section"
        fluid={bgImageData.file.childImageSharp.fluid}
        className={mainImageSection}
      />
    </section>
  );
};

export default AboutPageIntro;
